import axios from 'axios';
import { GET_QUESTION_TYPES } from './types';
import { throwError } from '../../actions/error/index';
import getAuthToken from '../../formatting/getAuthToken';

export function getQuestionTypes(query) {
    return async function (dispatch) {
        try {
            const q = query ? `?${query}` : '';
            const response = await axios.get(`/api/v1/question-types${q}`, {
                headers: { authorization: getAuthToken() },
            });
            dispatch({ type: GET_QUESTION_TYPES, payload: response });
            return response;
        } catch (error) {
            dispatch(
                throwError(
                    error,
                    'Something went wrong. We are working on a fix now!',
                ),
            );
        }
    };
}
